// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import { Container, Row, Col } from "react-bootstrap";
import RoutPath from "../RoutPath";
import Avatar from "./Avatar";
import AccountList from "./AccountList";
import Name from "./Name";
import Phone from "./Phone";
import Email from "./Email";

// import assets
import "../../assets/css/account.css";
import avatar from "../../assets/img/user_pic.jpg";

// import data

const PersonalInfo = () => {
    const [name, setName] = useState("احمد طه");
    const [phone, setPhone] = useState("123456");
    const [email, setEmail] = useState("mido@mido.com");

    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();

    const changeName = (e) => {
        setName(e);
    };
    const changePhone = (e) => {
        setPhone(e);
    };
    const changeEmail = (e) => {
        setEmail(e);
    };

    return (
        <section className="ocean-section personal-info-section">
            <Container>
                <Row>
                    <RoutPath />
                </Row>
                <Row>
                    {windowWidth >= 992 && (
                        <Col lg={4}>
                            <Avatar
                                avatar={avatar}
                                name={name}
                                points={120}
                                lgClass="lg-side-account-list"
                            />
                            <AccountList />
                        </Col>
                    )}
                    <Col lg={8} className="pb-5 ">
                        <h1 className="ocean-h1">{t("account.list.info")}</h1>
                        <Avatar
                            avatar={avatar}
                            name={name}
                            points={120}
                            lgClass="lg-personal-info-avatar pb-3"
                        />

                        <div className="personal-info-container product-section-div">
                            <Name name={name} onHandleChange={changeName} />
                            <Phone phone={phone} onHandleChange={changePhone} />
                            <Email email={email} onHandleChange={changeEmail} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default PersonalInfo;
